import { createSlice } from "@reduxjs/toolkit";
import { roleIds } from "../../constant";

const initialState = {
  role_id: null,
  role: null,
  token: null,
  user_id: null,
  is_email_verified: null,
  is_blocked: null,
  company_name: null,
  full_name: null,
  email: null,
  profile_url: null,
  offer_shown: false,
};

export const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthLogin: (state, actions) => {
      const {
        role_id,
        role,
        token,
        user_id,
        company_name,
        full_name,
        email,
        is_blocked,
        profile_url,
        is_email_verified,
        customer_id,
        contact_person,
        is_agree_terms,
        user,
      } = actions.payload;
      if (role_id !== undefined) state.role_id = role_id;
      else {
        state.role_id = roleIds.Customer;
      }

      if (token !== undefined) state.token = token;
      if (user_id !== undefined) state.user_id = user_id;
      if (company_name !== undefined) state.company_name = company_name;
      if (full_name !== undefined) state.full_name = full_name;
      if (email !== undefined) state.email = email;
      if (is_blocked !== undefined) state.is_blocked = is_blocked;
      if (profile_url !== undefined) state.profile_url = profile_url;
      if (is_email_verified !== undefined)
        state.is_email_verified = is_email_verified;
      if (role !== undefined) state.role = role;
      if (customer_id !== undefined) state.customer_id = customer_id;
      if (contact_person !== undefined) state.contact_person = contact_person;
      if (is_agree_terms !== undefined) state.is_agree_terms = is_agree_terms;
      if (user !== undefined) state.user = user;
      if (state.role_id) {
        state.is_sales_manager = state.role_id === roleIds.SalesManager;
        state.is_sales_person = state.role_id === roleIds.SalesPerson;
        state.is_customer = state.role_id === roleIds.Customer;
        state.is_admin = state.role_id === roleIds.Admin;
      }
    },
    setOfferShown: (state) => {
      state.offer_shown = true;
    },
    resetState: () => {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("filters:") || key.startsWith("pagination:")) {
          sessionStorage.removeItem(key);
        }
      });
      return initialState;
    },
  },
});

export const { setAuthLogin, setOfferShown, resetState } = loginSlice.actions;

export default loginSlice.reducer;
